import { styled } from 'styled-components'
import { Link, useLocation } from 'react-router-dom'
import { Menu } from 'antd'
import {
  AuditOutlined,
  BarcodeOutlined,
  GlobalOutlined,
  TruckOutlined,
  MessageOutlined,
  QuestionCircleOutlined,
  SendOutlined,
  ShopOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { StageNotify, getPermittedValues } from '../..'
import { withConfig } from '../../../modules'
import { configPropTypes } from '../../../types'

/* eslint-disable */
const POSSIBLE_ITEMS = {
  admin_user: {
    icon: <AuditOutlined />,
    key: "/admin-user",
    label: <Link to="/admin-user">Admins</Link>,
    name: "adminUserSideMenuItemSelenium",
  },
  country: {
    icon: <GlobalOutlined />,
    key: "/countries",
    label: <Link to="/countries">Countries</Link>,
    name: "countriesManagementSideMenuItemSelenium",
  },
  store: {
    icon: <ShopOutlined />,
    key: "/stores",
    label: <Link to="/stores">Stores</Link>,
    name: "storesSideMenuitemSelenium",
  },
  reverse_dc: {
    icon: <TruckOutlined />,
    key: "/reverse-dc",
    label: <Link to="/reverse-dc">Reverse DCs</Link>,
    name: "reverseDCSideMenuitemSelenium",
  },
  user: {
    icon: <UserOutlined />,
    key: "/users",
    label: <Link to="/users">Users</Link>,
    name: "usersSideMenuItemSelenium",
  },
  scan: {
    icon: <BarcodeOutlined />,
    key: "/scans",
    label: <Link to="/scans">Scans</Link>,
    name: "scansSideMenuItemSelenium",
  },
  withdrawal: {
    icon: <SendOutlined />,
    key: "/withdrawals",
    label: <Link to="/withdrawals">Withdrawals</Link>,
    name: "withdrawalsSideMenuItemSelenium",
  },
  faq: {
    icon: <QuestionCircleOutlined />,
    key: "/FAQs",
    label: <Link to="/FAQs">FAQs</Link>,
    name: "FAQsSideMenuItemSelenium",
  },
  notification: {
    icon: <MessageOutlined />,
    key: "/notifications",
    label: <Link to="/notifications">Notifications</Link>,
    name: "notificationsSideMenuItemSelenium",
  },
};
/* eslint-enable */

export const SideMenu = ({ config }) => {
  const location = useLocation()

  const items = getPermittedValues(POSSIBLE_ITEMS, config.config.user_permissions)

  return (
    <StageNotify>
      <StyledMenu items={items} mode="inline" selectedKeys={[location.pathname]} />
    </StageNotify>
  )
}

const StyledMenu = styled(Menu)`
  height: 100vh;
  width: 100%;

  padding: 20px 0 80px;
  border-right: 0;

  overflow: scroll;
`

SideMenu.propTypes = {
  config: configPropTypes,
}

export default withConfig(SideMenu)
